// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"aaa5a6b7","887":"3a9d59d0"}[chunkId] + ".chunk.css";
};